import React from 'react';
import ReactDOM from 'react-dom';
import { isEmpty, get } from 'lodash/fp';
// eslint-disable-next-line import/no-extraneous-dependencies
import { AppContainer } from 'react-hot-loader';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import 'url-polyfill';
import { MuiThemeProvider, StylesProvider, createGenerateClassName } from '@material-ui/core/styles';
import App from './App';
import './styles.less';
import 'emoji-mart/css/emoji-mart.css';
import Loader from './Components/Loader';
import theme from './Themes/Themes';
import { USER_TOKEN } from './Constants/AppConstants';

const url = new URL(window.location.href);
const service = url.searchParams.get('service');
const token = url.searchParams.get('token');
initializeIcons();

if (!isEmpty(token)) {
  localStorage.setItem(USER_TOKEN, token);
}

let isOfficeInitialized = false;

const selectService = (selected) => {
  if (selected && !isEmpty(token)) {
    return service;
  }
  if (!isEmpty(get('Office.context.mailbox.userProfile.emailAddress', window))) {
    return 'outlook';
  }
  return 'error';
};

const generateClassName = createGenerateClassName({
  productionPrefix: 'k',
  disableGlobal: true,
});

const render = (Component) => {
  ReactDOM.render(
    <AppContainer>
      <MuiThemeProvider theme={theme}>
        <StylesProvider generateClassName={generateClassName}>
          <Component service={selectService(service)} />
        </StylesProvider>
      </MuiThemeProvider>
    </AppContainer>,
    document.getElementById('container'),
  );
};

const Loading = () => (<Loader />);

const loadScript = (callback) => {
  const { head } = document;
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://appsforoffice.microsoft.com/lib/1/hosted/office.js';
  script.onreadystatechange = callback;
  script.onload = callback;
  head.appendChild(script);
};

const officeInitialize = () => {
  Office.initialize = () => {
    isOfficeInitialized = true;
    render(App);
  };
  render(Loading);
};

if (isEmpty(service)) {
  loadScript(officeInitialize);
} else {
  isOfficeInitialized = true;
  render(App);
}

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = isOfficeInitialized ? App.default : Loading;
    render(NextApp);
  });
}
